import React, { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useList } from "@/lib/hooks";
import api, { apiError } from "@/lib/api";
import { Panel } from "@/components/common";
import { Switch } from "@/components/ui/switch";
import { RazorpayCardButton } from "@/components/RazorpayCheckout";
import { CreditCard } from "@phosphor-icons/react";
import { toast } from "sonner";

export function CarrierBankPanel() {
  const qc = useQueryClient();
  const { data } = useList("pay-bank", "/payments/bank");
  const [consent, setConsent] = useState(false);
  if (!data) return null;
  const b = data.bank;
  const refresh = () => { qc.invalidateQueries({ queryKey: ["pay-bank"] }); qc.invalidateQueries({ queryKey: ["carrier-portal"] }); };
  const toggle = async (v) => {
    try { await api.put("/payments/autopay", { enabled: v }); toast.success(v ? "Auto pay on" : "Auto pay off"); refresh(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  return (
    <Panel className="p-5 lg:col-span-2" data-testid="cp-bank-panel">
      <h3 className="font-heading font-bold text-slate-900 mb-3 flex items-center gap-2"><CreditCard size={18} />Saved Card & Auto Pay</h3>
      {b && (
        <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
          <div><p className="font-semibold text-slate-900" data-testid="cp-bank-name">{b.institution} ••{b.mask}</p>
            <p className="text-xs text-slate-500 mt-0.5">Every Friday your unpaid invoices are charged to this card in USD when auto pay is on.</p></div>
          <label className="flex items-center gap-2 text-sm font-semibold text-slate-700">Auto pay
            <Switch checked={!!b.autopay} disabled={b.status !== "active"} onCheckedChange={toggle} data-testid="cp-autopay-switch" /></label>
        </div>
      )}
      {!data.enabled ? <p className="text-sm text-slate-500" data-testid="cp-bank-unavailable">Card payments are being activated.</p> : (
        <div className="space-y-3">
          <label className="flex items-start gap-2 text-xs text-slate-500 max-w-3xl">
            <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5" data-testid="cp-bank-consent" />{data.authorization}
          </label>
          <RazorpayCardButton setupUrl="/payments/bank/setup" confirmUrl="/payments/bank/confirm" consent={consent} onSaved={refresh} testid="cp-bank-link"
            className="h-9 px-4 rounded-full bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700 disabled:opacity-60">{b ? "Replace Card" : "Save a Card"}</RazorpayCardButton>
        </div>
      )}
    </Panel>
  );
}
